import { SettingsActions } from './actions'
import { SettingsGetters } from './getters'
import { SettingsMutations } from './mutations'
import { SettingsState } from './state'

export const SETTINGS_NAMESPACE = 'settingsModule'

export const Settings = {
  namespaced: true,
  state: SettingsState,
  actions: SettingsActions,
  mutations: SettingsMutations,
  getters: SettingsGetters,
}
